import { RouteObject } from "react-router-dom";
import {
  Home,
  Landing,
  Sport,
  EventPage,
  Highlight,
  Checkout,
  Search,
  UserProfile,
  Partner,
  About,
  Contact,
  Pricing,
  Cookies,
  Faq,
  Privacy,
  Terms,
  Redirect
} from "pages";
import { SignUp } from "pages/Static/SignUp";

export const APP_ROUTES: RouteObject[] = [
  {
    path: "/",
    Component: Landing
  },
  {
    path: "/sport/:sport",
    Component: Sport
  },
  {
    path: "/search",
    Component: Search
  },
  {
    path: "/verify-code",
    Component: Redirect
  },
  {
    path: "/partner/:uuid",
    Component: Partner
  },
  {
    path: "/highlights/:uuid",
    Component: Highlight
  },
  {
    path: "/events/:uuid",
    Component: EventPage
  },
  {
    path: "/event/:uuid/checkout",
    Component: Checkout
  },
  {
    path: "/privacy",
    Component: Privacy
  },
  {
    path: "/terms",
    Component: Terms
  },
  {
    path: "/cookies",
    Component: Cookies
  },
  {
    path: "/faq",
    Component: Faq
  },
  {
    path: "/about",
    Component: About
  },
  {
    path: "/contact",
    Component: Contact
  },
  {
    path: "/pricing",
    Component: Pricing
  },
  {
    path: '/signup',
    Component: SignUp
  }
];

export const AUTHENTICATED_ROUTES: RouteObject[] = [
  {
    path: "/home",
    Component: Home
  },
  {
    path: "/profile",
    Component: UserProfile
  },
  {
    path: "/event/:uuid/checkout",
    Component: Checkout
  }
];

export const NONE_AUTHENTICATED_ROUTES: RouteObject[] = [];
